<app-loader [show]="isLoading"></app-loader>
<div class="employee-type-component-container page-root-container page-list-component-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/employee-type.svg">
            <span class="title">Employee Type</span>
        </div>
        <div class="page-actions">
        </div>
    </div>

    <div class="data-container">
        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>
        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="item-header" style="width: 50px;">#</th>
                    <td mat-cell *matCellDef="let row; let i = index" class="item-column" style="width: 50px;">
                        {{ (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-sort-header="code" mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                        style="width: 80px;">Code</th>
                    <td mat-cell *matCellDef="let row" style="width: 80px;">
                        <span [style.background-color]="row.bg_color" [style.color]="row.fg_color"
                            [style.border-color]="row.fg_color"
                            style="padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; display: inline-block; border: 1px solid;">
                            {{row.code}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="name" mat-header-cell *matHeaderCellDef (click)="sortData($event)">Name</th>
                    <td mat-cell *matCellDef="let row">{{row.name}}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-sort-header="description" mat-header-cell *matHeaderCellDef (click)="sortData($event)">
                        Description</th>
                    <td mat-cell *matCellDef="let row">{{row.description}}</td>
                </ng-container>

                <ng-container matColumnDef="is_active">
                    <th mat-sort-header="is_active" mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                        style="width: 80px; text-align: center;">Active</th>
                    <td mat-cell *matCellDef="let row" style="width: 80px; text-align: center;">
                        <span *ngIf="row.is_active"
                            style="background-color: #e6f4ea; color: #137333; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 500; display: inline-block;">Active</span>
                        <span *ngIf="!row.is_active"
                            style="background-color: #fce8e6; color: #c5221f; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 500; display: inline-block;">Inactive</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
                    <td mat-cell class="row-menu-btn" *matCellDef="let rowItem" style="width: 50px; text-align: right;">
                        <a mat-icon-button [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(rowItem);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            @if(permissionService.getRowPermission(permission,rowItem.id).can_edit){
                            <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                            }
                            @else{
                            <button mat-menu-item (click)="onEdit(rowItem)">View</button>
                            }
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let row; columns: displayedColumns;"
                    (click)="onRowSelected(row)" (dblclick)="onEdit(row)"
                    [ngClass]="{'row-selected' : row.id===selectedItem?.id}"></tr>
            </table>
        </section>

        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found.</span>
    </div>
    }
</div>
</div>